import { convertToIsoDateTime } from "../datetime";

const enforcementCreatePayload = (data, officer, siteGuid) => {
  return {
    rowVersion: data.rowVersion,
    id: data.id,
    incidentDate: convertToIsoDateTime(data.date, data.time),
    incidentStatus: {
      id: 2,
      name: "In Review",
    },
    incidentType: {
      id: 1,
      name: "Enforcement Visit",
    },
    site: { guid: siteGuid },
    enforcementVisit: {
      isGamblingRelated: data.isGamblingRelated,
      officerId: data.officer.id ? data.officer.id : 0,
      enforcementVisitType: { id: data.officerTypeId, name: "" },
      officer: data.officer,
      visitDetails: data.visitDetails,
      incidentNumber: data.incidentNumber,
      comments: data.comments,
    },
    customerIncident: null,
    gamblingDispute: null,
    suspiciousActivity: null,
  };
};

export default enforcementCreatePayload;
